import {Component, Bind, Ref, PreventDefault, HttpClient, LogExceptions, Trace, LogLevel} from "xm-ui";
import {IReplyOptions} from "./IReplyOptions";
import {SpinnerComponent} from "./SpinnerComponent";

export class MessengerReplyComponent extends Component<IReplyOptions> {
    @Ref('.message-box') messageBox: JQuery;
    @Ref('.message-shadow') messageShadow: JQuery;
    @Ref('.send-button') sendButton: JQuery;

    private http: HttpClient;

    constructor(options?: IReplyOptions) {
        super(options);

        this.http = new HttpClient();
    }

    protected render(childNodes: Promise<JQuery>[]): Promise<JQuery> {
        return (
            <footer class="composer">
                <pre class="message-shadow"></pre>
                <textarea class="message-box" placeholder={this.options.placeholder}/>
                <span class="send-button disabled">
                    {`<svg width="24" height="24" viewBox="0 0 24 24">
                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                    </svg>`}
                </span>
            </footer>
        );
    }

    protected getDefaultOptions(): Partial<IReplyOptions> {
        return $.extend(super.getDefaultOptions(), {
            api: {},
            user: {},
            minHeight: 54,
            maxHeight: 200,
            minTextLength: 3,
            placeholder: "Write a reply...",
            messageSent: "Thank you for your reply.",
            errorOccurred: "Some error occurred."
        });
    }

    protected onMount() {
        setTimeout(() => {
            this.messageBox.focus().blur();
        });
    }

    @Trace(LogLevel.Info)
    @LogExceptions()
    private async post() {
        let message = this.messageBox.val();

        if (!message || message.length < this.options.minTextLength!)
            return;

        this.messageBox.val("");
        this.onTextChanged();

        let spinner = new SpinnerComponent();
        let spinnerHtml = await spinner.build([]);
        this.getHostElement().empty().append(spinnerHtml);

        try {
            let response = await this.http.post(`${this.options.api!.baseAddress}/Comment`, {
                apiKey: this.options.api!.key,
                key: `abc-messenger/${this.options.key}`,
                userId: this.options.user!.id,
                userName: this.options.user!.name,
                userImage: this.options.user!.image,
                text: message,
                contentId: this.options.key,
                language: this.options.api!.language,
                attributes: this.options.attributes
            });

            this.getHostElement().html(`<p class="message-box success">${this.options.messageSent}</p>`);
        }
        catch(e) {
            this.getHostElement().html(`<p class="message-box fail">${this.options.errorOccurred}</p>`);
        }
    }

    @Bind("keyup paste", ".message-box")
    private onTextChanged() {
        let oldHeight = this.getHostElement().outerHeight();
        let message = this.messageBox.val();
        this.messageShadow.html(message + "<br>");

        let newHeight = this.messageShadow.outerHeight();

        if (newHeight > this.options.maxHeight!)
            newHeight = this.options.maxHeight!;

        if (newHeight < this.options.minHeight!)
            newHeight = this.options.minHeight!;

        if (oldHeight !== newHeight) {
            this.getHostElement()
                .trigger('resized', [newHeight])
                .height(newHeight);
        }

        this.sendButton.toggleClass("disabled", message.length < this.options.minTextLength!);
    }

    @PreventDefault()
    @Bind("click", ".send-button")
    private onSendButtonClick() {
        this.post();
    }

    @Bind("keydown", ".message-box")
    private onCtrlEnter(event: JQueryKeyEventObject) {
        if (event.ctrlKey && event.keyCode == 13) {
            this.post();
        }
    }
}



// WEBPACK FOOTER //
// ./components/MessengerReplyComponent.tsx